export default __webpack_public_path__ + "static/Card16-66351f171fd4f44407d6daabe7967f8c.png";